import { defineMessages } from 'react-intl'

export default defineMessages({
    notAvailable: {
        defaultMessage: 'Lo sentimos, no hay puntos de carga eléctrica en esta zona',
    },
    notAvailableSubtitle: {
        defaultMessage: 'Cambia la ubicación de tu búsqueda para buscar en otra zona',
    },
    notFound: {
        defaultMessage: 'Lo sentimos, no hemos encontrado resultados',
    },
})
